import React, { Component } from 'react';
import { Button, Row, Col, Alert } from 'reactstrap';
import axiosInstance from '@src/axios-instance';
import ConfirmModal from '@components/ConfirmModal/ConfirmModal';

class CoverLetter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      successCoverLetter: false,
      coverLetter: '',
      confirmModalActive: false
    };
  }

  openFilePicker = () => {
    this.fileUpload.click();
  };

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  onFileSelect = e => {
    if (this.fileUpload.files.length > 0) {
      const formData = new FormData();
      formData.append('file', this.fileUpload.files[0]);

      axiosInstance()
        .post('/tenants/cover-letter.json', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          this.setState({
            coverLetter: response.data,
            successCoverLetter: 'Condo Questionnaire has been updated.'
          });
        })
        .catch(err => {
          alert('Error');
        });
      this.fileUpload.value = '';
    }
  };

  onCoverLetterRemove = e => {
    axiosInstance()
      .get('/tenants/remove-cover-letter.json')
      .then(response => {
        this.setState({
          coverLetter: '',
          confirmModalActive: false,
          successCoverLetter: 'Condo Questionnaire has been removed.'
        });
      })
      .catch(err => {});
  };

  componentDidMount = () => {
    axiosInstance()
      .get('/tenants/get-current.json')
      .then(response => {
        this.setState({
          loaded: true,
          coverLetter: response.data.cover_letter
        });
      });
  };

  render = () => {
    return (
      <React.Fragment>
        {this.state.loaded && (
          <div>
            <Row>
              <Col>
                <h3>
                  Upload the default Condo Questionnaire document here.
                  <Button
                    color={'secondary'}
                    className={'float-right'}
                    size={'sm'}
                    onClick={this.openFilePicker}
                  >
                    Upload New
                  </Button>
                  <input
                    ref={ref => (this.fileUpload = ref)}
                    type={'file'}
                    className={'d-none'}
                    onChange={this.onFileSelect}
                    accept={'.pdf'}
                  />
                </h3>
                <p>Supported file formats: PDF</p>
                <p>
                  <strong>Preview</strong>
                </p>
                <Row>
                  <Col xs={9}>
                    {this.state.successCoverLetter !== false && (
                      <Alert color="success">
                        {this.state.successCoverLetter}
                      </Alert>
                    )}
                    <div className={'border-bottom text-center'}>
                      {this.state.coverLetter.length === 0 ? (
                        'NO CONDO QUESTIONNAIRE'
                      ) : (
                        <a href={this.state.coverLetter}>
                          {
                            this.state.coverLetter
                              .substring(
                                this.state.coverLetter.lastIndexOf('/') + 1
                              )
                              .split('?')[0]
                          }
                        </a>
                      )}
                    </div>
                  </Col>
                  <Col xs={3}>
                    {this.state.coverLetter.length !== 0 && (
                      <Button
                        color={'danger'}
                        onClick={() => this.toggle('confirmModalActive')}
                      >
                        Remove
                      </Button>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
            <ConfirmModal
              isActive={this.state.confirmModalActive}
              toggle={() => this.toggle('confirmModalActive')}
              body={'Please confirm to delete this condo questionnaire.'}
              confirmLabel={'Yes, delete this condo questionnaire'}
              confirmAction={this.onCoverLetterRemove}
            />
          </div>
        )}
      </React.Fragment>
    );
  };
}
export default CoverLetter;
